export class JustpayPaymentModel {
    constructor () {
        this.id = ''
        this.created = ''
        this.date = ''
        this.sum = 0
        this.items_name = ''
        this.point_name = ''
        this.address
        this.state
        this.type
    }
}
